import {API_ENDPOINT_JSON} from '../../../../../config';

export const getTcfdUrl = (pillarId: string, subCategory: string): string => {
  return `${API_ENDPOINT_JSON.ESG.TCFD.tcfd}/${pillarId}/${subCategory}`;
};
